export default __webpack_public_path__ + "static/media/AlainaLovelace.78af2326.png";